import { cva, type VariantProps } from "class-variance-authority";

export const cardVariants = cva("card", {
  variants: {
    variant: {
      default: null,
      raised: "card--raised",
      inset: "card--inset",
      glow: "card--glow",
    },
  },
  defaultVariants: { variant: "default" },
});

export type CardVariant = NonNullable<VariantProps<typeof cardVariants>["variant"]>;
